<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "InPageHelpWrapper"
    }
</script>

<style scoped>

</style>